export type GreetingPeriod = 'morning' | 'noon' | 'afternoon' | 'evening' | 'night';

/**
 * Hour (0–23, local time) → greeting bucket.
 *
 *   05–11 morning · 12–15 noon · 16–17 afternoon · 18–21 evening
 *   · 22–04 night
 *
 * Same buckets as the Rmobile CRM; English, Arabic and French collapse some
 * of them onto the same phrase in the locale files.
 */
export function greetingPeriod(hour: number): GreetingPeriod {
    if (hour >= 5 && hour < 12) return 'morning';
    if (hour >= 12 && hour < 16) return 'noon';
    if (hour >= 16 && hour < 18) return 'afternoon';
    if (hour >= 18 && hour < 22) return 'evening';
    return 'night';
}

/** "Dana Levi" → "Dana"; empty or missing names give "". */
export function firstName(fullName: string | null | undefined): string {
    return (fullName ?? '').trim().split(/\s+/)[0] ?? '';
}

const INTL_LOCALE: Record<string, string> = { en: 'en-GB', ar: 'ar', fr: 'fr-FR' };

/** "Thursday 8 October 2026" in the user's language, Latin digits. */
export function dashboardDate(date: Date, language: string): string {
    return new Intl.DateTimeFormat(INTL_LOCALE[language.split('-')[0]] ?? 'en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        numberingSystem: 'latn',
    }).format(date);
}
